/* Why Choose REIBII 选项卡切换。作用域按 section 根节点隔离，
   同页多实例互不影响，主题编辑器里增删/选中区块也会重新初始化。 */
(function () {
  'use strict';

  var MODULE_KEY = '__reibiiAboutWhyChooseModule';
  if (window[MODULE_KEY]) {
    window[MODULE_KEY].initAll();
    return;
  }

  function initSection(root) {
    if (!root || root._aboutWhyChooseReady) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-why-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-why-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;

    root._aboutWhyChooseReady = true;

    var scroller = root.querySelector('[data-why-tabs]');
    var handlers = [];

    /* 用 rect 相对容器算偏移。offsetLeft 取的是最近定位祖先，
       容器本身没有定位上下文时会把页面边距一起算进去，导致选中项偏左。 */
    function scrollTabIntoView(tab) {
      if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;
      var tabRect = tab.getBoundingClientRect();
      var boxRect = scroller.getBoundingClientRect();
      var offset = scroller.scrollLeft + tabRect.left - boxRect.left;
      var left = offset - (scroller.clientWidth - tabRect.width) / 2;
      var max = scroller.scrollWidth - scroller.clientWidth;
      /* 直接赋值而不是 scrollTo({behavior:'smooth'})：动画交给 CSS 的
         scroll-behavior，浏览器不做动画时位置依然会落到正确的值。 */
      scroller.scrollLeft = Math.max(0, Math.min(max, left));
    }

    function activate(index, moveFocus) {
      if (index < 0 || index >= tabs.length) return;
      tabs.forEach(function (tab, i) {
        var current = i === index;
        tab.classList.toggle('is-active', current);
        tab.setAttribute('aria-selected', current ? 'true' : 'false');
        tab.setAttribute('tabindex', current ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var current = i === index;
        panel.classList.toggle('is-active', current);
        panel.hidden = !current;
      });
      scrollTabIntoView(tabs[index]);
      if (moveFocus) tabs[index].focus();
    }

    tabs.forEach(function (tab, index) {
      var onClick = function () {
        activate(index, false);
      };
      var onKeydown = function (event) {
        var step = 0;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') step = 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') step = -1;
        if (!step) return;
        event.preventDefault();
        activate((index + step + tabs.length) % tabs.length, true);
      };
      tab.addEventListener('click', onClick);
      tab.addEventListener('keydown', onKeydown);
      handlers.push({ tab: tab, click: onClick, keydown: onKeydown });
    });

    function onBlockSelect(event) {
      if (!root.contains(event.target)) return;
      var panel = event.target.closest ? event.target.closest('[data-why-panel]') : null;
      if (!panel) return;
      var index = panels.indexOf(panel);
      if (index > -1) activate(index, false);
    }

    function destroy() {
      document.removeEventListener('shopify:block:select', onBlockSelect);
      handlers.forEach(function (item) {
        item.tab.removeEventListener('click', item.click);
        item.tab.removeEventListener('keydown', item.keydown);
      });
      root._aboutWhyChooseReady = false;
      root._aboutWhyChooseDestroy = null;
    }

    document.addEventListener('shopify:block:select', onBlockSelect);
    root._aboutWhyChooseDestroy = destroy;

    var initial = 0;
    tabs.forEach(function (tab, i) {
      if (tab.classList.contains('is-active')) initial = i;
    });
    activate(initial, false);
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-about-why-choose]');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function findRoot(target) {
    if (!target) return null;
    if (target.matches && target.matches('[data-about-why-choose]')) return target;
    return target.querySelector ? target.querySelector('[data-about-why-choose]') : null;
  }

  function onSectionLoad(event) {
    var root = findRoot(event.target);
    if (root) initSection(root);
  }

  function onSectionUnload(event) {
    var root = findRoot(event.target);
    if (root && root._aboutWhyChooseDestroy) root._aboutWhyChooseDestroy();
  }

  window[MODULE_KEY] = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
